export interface HeroPropsInterface {
  contentAlign?: string
  height?: string
  mediaId?: string | number
  mediaType?: string
  mediaSizes?: string | Record<string, any>
  mediaAlt?: string
  mediaUrl?: string
  previewMediaId?: string | number
  previewMediaType?: string
  previewMediaSizes?: string | Record<string, any>
  previewMediaAlt?: string
  previewMediaUrl?: string
  backgroundPositionY?: string
  backgroundPositionX?: string
  mediaIdDesktop?: string
  mediaTypeDesktop?: string
  mediaSizesDesktop?: string | Record<string, any>
  mediaAltDesktop?: string
  mediaUrlDesktop?: string
  previewMediaIdDesktop?: string
  previewMediaTypeDesktop?: string
  previewMediaSizesDesktop?: string | Record<string, any>
  previewMediaAltDesktop?: string
  previewMediaUrlDesktop?: string
  backgroundPositionYDesktop?: string
  backgroundPositionXDesktop?: string
  iconMediaId?: string
  iconMediaType?: string
  iconMediaSizes?: string | Record<string, any>
  iconMediaAlt?: string
  iconMediaUrl?: string
  fontColor?: string
  colorGradient?: string
  pageUrl?: string | null
  pageUrlLabel?: string
  calculatorShow?: string
  isBusinessActive?: string
  calculatorBranches?: string
  calculatorLabelExtra?: string | null
  disruptorBackground?: string
}

export const HeroPropsDefaults: HeroPropsInterface = {
  contentAlign: 'start',
  height: 'medium',
  mediaId: '0',
  mediaType: '',
  mediaAlt: '',
  mediaUrl: '',
  previewMediaId: '0',
  previewMediaType: '',
  previewMediaAlt: '',
  previewMediaUrl: '',
  backgroundPositionY: 'top',
  backgroundPositionX: 'center',
  mediaIdDesktop: '0',
  mediaTypeDesktop: '',
  mediaAltDesktop: '',
  mediaUrlDesktop: '',
  previewMediaIdDesktop: '0',
  previewMediaTypeDesktop: '',
  previewMediaAltDesktop: '',
  previewMediaUrlDesktop: '',
  backgroundPositionYDesktop: 'top',
  backgroundPositionXDesktop: 'center',
  iconMediaId: '0',
  iconMediaType: '',
  iconMediaAlt: '',
  iconMediaUrl: '',
  fontColor: 'white',
  colorGradient: '',
  pageUrlLabel: 'Mehr erfahren',
  pageUrl: null,
  calculatorShow: 'false',
  isBusinessActive: 'false',
  calculatorBranches: 'all',
  calculatorLabelExtra: null,
  disruptorBackground: 'red-orange',
};
